import { TYPE2CLASS } from '../core/icon-class';
import { Fact } from '../common/fact';

class FactThumbController {
  constructor() {
    this.isImage = Fact.isImage;
  }

  get icon() {
    return this.fact && TYPE2CLASS[this.fact['agent_eventtype.name']];
  }
}

export const FactThumbComponent = {
  bindings  : {
    filter   : '<',
    fact     : '<',
    showImage: '<',
    listType : '<',
    selected : '<',
  },
  controller: FactThumbController,
  template  : require('./fact-thumb.component.html'),
};



// WEBPACK FOOTER //
// ./src/facts/fact-thumb.component.js